export default {
  form: {
    padding: 10,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    margin: 5,
    height: 200,
    width: 200,
  },
  noQuestionsContainer: {
    textAlign: 'center',
  },
  noQuestions: {
    height: 150,
    fontSize: 180,
    color: 'lightgrey',
  },
  body: {
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 2,
  },
  addQuestion: {
    position: 'absolute',
    top: -26,
    right: 10,
  },
  content: {
    padding: 10,
  },
  type: {
    padding: 5,
  },
  typeName: {
    // lineHeight: 23,
  },
  typeDesc: {
    fontSize: 12,
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/StageDialog/styles.js